const FORMATS = [
  /^ATU\d{8}$/,
  /^BE\d{10}$/,
  /^BG\d{9,10}$/,
  /^CHE\d{3}\.\d{3}\.\d{3} (MWST|TVA|IVA)$/,
  /^CY\d{8}[A-Z]{1}$/,
  /^CZ\d{8,10}$/,
  /^DE\d{9}$/,
  /^DK\d{8}$/,
  /^EL\d{9}$/,
  /^EE\d{9}$/,
  /^ES[A-Z0-9]{1}\d{7}[A-Z0-9]{1}$/,
  /^FI\d{8}$/,
  /^FR[0-9A-HH-NP-Z]{2}\d{9}$/,
  /^GB\d{9}$/,
  /^HR\d{11}$/,
  /^HU\d{8}$/,
  /^IE((\d{6}[A-Z]{2})|(\d{7}[A-Z]{1}))$/,
  /^IT\d{11}$/,
  /^LT(\d{9}|\d{12})$/,
  /^LU\d{8}$/,
  /^LV\d{11}$/,
  /^MT\d{8}$/,
  /^NL\d{9}B\d{2}$/,
  /^(NO)?\d{9}MVA$/,
  /^PL\d{10}$/,
  /^PT\d{9}$/,
  /^RO\d{2,10}$/,
  /^SE\d{12}$/,
  /^SI\d{8}$/,
  /^SK\d{10}$/,
]

module.exports = function() {
  return value => {
    for (const format of FORMATS) {
      if (format.test(value)) return true
    }
    return false
  }
}
